import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Frame } from '../components/Frame';
import { KrabenMark } from '../components/KrabenMark';
import { fetchInvite, acceptInvite } from '../lib/challenges';
import { loadProfile, saveProfile } from '../lib/state';
import { writeUserDoc } from '../lib/feed';
import { track } from '../analytics';
import { useViewed } from '../lib/viewed';

/** A friend's invite link: accept, and you two see each other's things. Then the front door. */
export function InvitePage() {
  useViewed('invite');
  const { code = '' } = useParams();
  const nav = useNavigate();
  const [inv, setInv] = useState<{ code: string; fromName: string } | null | undefined>(undefined);
  const [name, setName] = useState(() => loadProfile().name || '');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  useEffect(() => { fetchInvite(code).then((x) => { setInv(x); if (x) track('invite_opened', { code }); }).catch(() => setInv(null)); }, [code]);

  if (inv === undefined) return <Frame><p className="hint">One moment…</p></Frame>;
  if (inv === null) return <Frame><h1>That link has gone.</h1><button className="btn ghost" onClick={() => nav('/')}>Start anyway</button></Frame>;

  const accept = async () => {
    setBusy(true);
    try {
      const n = name.trim().slice(0, 40) || undefined;
      if (n) { const p = { ...loadProfile(), name: n }; saveProfile(p); writeUserDoc({ name: n }).catch(() => {}); }
      await acceptInvite(code, n);
      track('invite_accepted', { code });
      setDone(true);
    } catch { setBusy(false); }
  };

  return (
    <Frame left={<span className="tag">From {inv.fromName}</span>}>
      <div className="row between"><h1>{done ? `You and ${inv.fromName} are friends here.` : `${inv.fromName} invited you.`}</h1><KrabenMark size={72} /></div>
      {done ? (
        <>
          <p className="why">You’ll see what each of you shares. Now, today’s exercise.</p>
          <div className="stack" style={{ marginTop: 'auto' }}><button className="btn coral" onClick={() => nav('/')}>Start Day 1</button></div>
        </>
      ) : (
        <>
          <p className="why">What you make stays private until you share it. Share it, and {inv.fromName} will see it.</p>
          {/* only for somebody new: a name already given (Who are you?, Day 2) is never asked for twice (owner, 2026-09-30) */}
          {!loadProfile().name && <div className="field"><label htmlFor="nm">Your first name, so {inv.fromName} knows it’s you</label><input id="nm" className="input" value={name} onChange={(e) => setName(e.target.value)} autoComplete="given-name" /></div>}
          <div className="stack" style={{ marginTop: 'auto' }}>
            <button className="btn coral" onClick={accept} disabled={busy}>{busy ? 'One moment' : 'Join'}</button>
            <button className="link" onClick={() => nav('/')}>Just start, no friends yet</button>
          </div>
        </>
      )}
    </Frame>
  );
}
